import type { EventContext, EventName } from "./types";
import { EVENTS } from "./core/constants";

export function pushToDataLayer(event: string, context: EventContext) {
  const targetWindow = context.window || (typeof window !== 'undefined' ? window : null);
  if (!targetWindow) return;

  const payload = Object.assign({}, context);
  delete payload.window; // delete window prop and avoid to push as payload to dayalayer

  const eventName = event.toUpperCase() as EventName;
  const eventConfig = EVENTS[eventName] as { hasEcommerce: boolean };

  targetWindow.dataLayer = targetWindow.dataLayer || [];

  if (eventConfig?.hasEcommerce) {
    targetWindow.dataLayer.push({ ecommerce: null });
    targetWindow.dataLayer.push({ event: event.toLowerCase(), ecommerce: payload });
  } else {
    targetWindow.dataLayer.push(Object.assign({ event: event.toLowerCase() }, payload));
  }
}